import type { ErrorTranslations } from "./utils";

export default {
  not_found: {
    EN: "Procedure not found",
    RO: "Procedura nu a fost găsită",
  },
  revert_error: {
    EN: "Error reverting step",
    RO: "Eroare la revenirea la pasul anterior",
  },
} satisfies ErrorTranslations;
